// DynamicAdapt - динамический адаптив
import { useDynamicAdapt } from './vendor/dynamicAdapt';

useDynamicAdapt();
